// // import React, { useRef, useState } from "react";
// // import * as XLSX from "xlsx";

// // export default function FabricProgramManager() {
// //   const fileInputRef = useRef();

// //   // -------------------- Client & Form Data --------------------
// //   const [formData, setFormData] = useState({
// //     companyName: "",
// //     season: "",
// //     po: "",
// //     reference: "",
// //     orderFollowedBy: "",
// //     orderFollowUpContact: "",
// //   });

// //   // -------------------- Process Losses (Customizable) --------------------
// //   const [losses, setLosses] = useState({
// //     knitting: 2,
// //     mercerizing: 7,
// //     dyeing: 4,
// //     finishing: 4,
// //     printing: 8,
// //   });

// //   // -------------------- Excel Data --------------------
// //   const [modifiedData, setModifiedData] = useState(null);

// //   // -------------------- Form Change Handlers --------------------
// //   const handleFormChange = (e) => {
// //     const { name, value } = e.target;
// //     setFormData((prev) => ({ ...prev, [name]: value }));
// //   };

// //   const handleLossChange = (e) => {
// //     const { name, value } = e.target;
// //     setLosses({ ...losses, [name]: parseFloat(value) || 0 });
// //   };

// //   // -------------------- Form Validation --------------------
// //   const isFormValid =
// //     formData.companyName.trim() &&
// //     formData.reference.trim() &&
// //     formData.orderFollowedBy.trim() &&
// //     formData.orderFollowUpContact.trim();

// //   // -------------------- Upload Excel --------------------
// //   const handleUploadClick = () => {
// //     if (!isFormValid) return;
// //     fileInputRef.current.click();
// //   };

// //   const handleFileChange = (event) => {
// //     const file = event.target.files[0];
// //     if (!file) return;

// //     const reader = new FileReader();
// //     reader.onload = (e) => {
// //       const data = new Uint8Array(e.target.result);
// //       const workbook = XLSX.read(data, { type: "array" });
// //       const sheet = workbook.Sheets[workbook.SheetNames[0]];
// //       let jsonData = XLSX.utils.sheet_to_json(sheet);

// //       // -------------------- Sort by Fabric then Dia --------------------
// //       jsonData.sort((a, b) => {
// //         const fabricA = (a["Fabric"] || "").toString().toLowerCase();
// //         const fabricB = (b["Fabric"] || "").toString().toLowerCase();
// //         if (fabricA < fabricB) return -1;
// //         if (fabricA > fabricB) return 1;

// //         const diaA = (a["Dia"] || "").toString();
// //         const diaB = (b["Dia"] || "").toString();
// //         return diaA.localeCompare(diaB);
// //       });

// //       // -------------------- Calculate Yarn Quantity (Reverse Efficiency) --------------------
// //       jsonData = jsonData.map((row) => {
// //         const requiredWeight = parseFloat(row["Required Weight"]) || 0;

// //         // Detect if Mercerizing / Printing applies
// //         const hasMercerizing =
// //           row["Mercerizing"]?.toString().toLowerCase() === "yes";
// //         const hasPrinting = row["Printing"]?.toString().toLowerCase() === "yes";

// //         // -------------------- Reverse Cumulative Efficiency --------------------
// //         // Start with cumulative efficiency = 1 (100%)
// //         let cumulativeEfficiency = 1;

// //         // Step 1: Knitting always applied
// //         cumulativeEfficiency *= 1 - losses.knitting / 100;

// //         // Step 2: Apply mercerizing if present
// //         if (hasMercerizing)
// //           cumulativeEfficiency *= 1 - losses.mercerizing / 100;

// //         // Step 3: Dyeing always applied
// //         cumulativeEfficiency *= 1 - losses.dyeing / 100;

// //         // Step 4: First finishing always applied
// //         cumulativeEfficiency *= 1 - losses.finishing / 100;

// //         // Step 5: Printing + second finishing only if printing present
// //         if (hasPrinting) {
// //           cumulativeEfficiency *= 1 - losses.printing / 100;
// //           cumulativeEfficiency *= 1 - losses.finishing / 100;
// //         }

// //         // Step 6: Yarn Required = Required Weight ÷ Cumulative Efficiency
// //         const yarnRequired = parseFloat(
// //           (requiredWeight / cumulativeEfficiency).toFixed(2)
// //         );

// //         // Remove Net Weight column if exists
// //         const { ["Net Weight"]: _, ...rest } = row;

// //         return {
// //           ...rest,
// //           "Yarn Quantity": yarnRequired,
// //         };
// //       });

// //       setModifiedData(jsonData);
// //     };
// //     reader.readAsArrayBuffer(file);
// //   };

// //   // -------------------- Download Template --------------------
// //   const handleDownloadTemplate = () => {
// //     if (!isFormValid) return;
// //     const publicPath = process.env.PUBLIC_URL + "/Fabric_Program_Template.xlsx";
// //     const link = document.createElement("a");
// //     link.href = publicPath;
// //     link.download = "Fabric_Program_Template.xlsx";
// //     document.body.appendChild(link);
// //     link.click();
// //     link.remove();
// //   };

// //   // -------------------- Download Modified Excel --------------------
// //   const handleDownloadModified = () => {
// //     if (!modifiedData) return;
// //     const worksheet = XLSX.utils.json_to_sheet(modifiedData);
// //     const workbook = XLSX.utils.book_new();
// //     XLSX.utils.book_append_sheet(workbook, worksheet, "Modified Data");
// //     XLSX.writeFile(workbook, "Modified_Fabric_Program.xlsx");
// //   };

// //   // -------------------- Render --------------------
// //   return (
// //     <div className="min-h-screen bg-gray-100 p-4 flex items-center justify-center">
// //       <div className="bg-white p-8 rounded-xl shadow-lg max-w-6xl w-full flex flex-col md:flex-row md:space-x-8">
// //         {/* Left Section: Client Details + Process Losses */}
// //         <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-6">
// //           {/* Client Details */}
// //           {[
// //             { label: "Client Name", name: "companyName", required: true },
// //             { label: "Season", name: "season" },
// //             { label: "PO", name: "po" },
// //             { label: "Reference", name: "reference", required: true },
// //             {
// //               label: "Order Followed By",
// //               name: "orderFollowedBy",
// //               required: true,
// //             },
// //             {
// //               label: "Order Follow up Contact",
// //               name: "orderFollowUpContact",
// //               required: true,
// //             },
// //           ].map((field) => (
// //             <label key={field.name} className="flex flex-col">
// //               <span className="font-medium text-gray-700">
// //                 {field.label}{" "}
// //                 {field.required && <span className="text-red-600">*</span>}
// //               </span>
// //               <input
// //                 name={field.name}
// //                 value={formData[field.name]}
// //                 onChange={handleFormChange}
// //                 type="text"
// //                 placeholder={`Enter ${field.label.toLowerCase()}`}
// //                 className="mt-1 px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
// //                 required={field.required}
// //               />
// //             </label>
// //           ))}

// //           {/* Process Losses Customization */}
// //           <div className="md:col-span-2">
// //             <h3 className="font-semibold mb-2">Customize Process Loss (%)</h3>
// //             <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
// //               {Object.keys(losses).map((key) => (
// //                 <label key={key} className="flex flex-col">
// //                   <span className="font-medium capitalize">{key} Loss (%)</span>
// //                   <input
// //                     type="number"
// //                     name={key}
// //                     value={losses[key]}
// //                     onChange={handleLossChange}
// //                     className="mt-1 px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
// //                   />
// //                 </label>
// //               ))}
// //             </div>
// //           </div>
// //         </div>

// //         {/* Right Section: Buttons */}
// //         <div className="flex flex-col space-y-4 mt-6 md:mt-0 md:flex-col md:justify-center md:w-48">
// //           <button
// //             onClick={handleDownloadTemplate}
// //             disabled={!isFormValid}
// //             className={`px-6 py-3 rounded-lg shadow text-white transition ${
// //               isFormValid
// //                 ? "bg-blue-600 hover:bg-blue-700"
// //                 : "bg-blue-300 cursor-not-allowed"
// //             }`}
// //           >
// //             Download Template
// //           </button>

// //           <button
// //             onClick={handleUploadClick}
// //             disabled={!isFormValid}
// //             className={`px-6 py-3 rounded-lg shadow text-white transition ${
// //               isFormValid
// //                 ? "bg-green-600 hover:bg-green-700"
// //                 : "bg-green-300 cursor-not-allowed"
// //             }`}
// //           >
// //             Upload File
// //           </button>

// //           <input
// //             type="file"
// //             ref={fileInputRef}
// //             onChange={handleFileChange}
// //             className="hidden"
// //           />

// //           {modifiedData && (
// //             <button
// //               onClick={handleDownloadModified}
// //               className="px-6 py-3 rounded-lg shadow text-white transition bg-purple-600 hover:bg-purple-700"
// //             >
// //               Download Modified Excel
// //             </button>
// //           )}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// // Version 1

// import React, { useRef, useState } from "react";
// import * as XLSX from "xlsx";

// export default function FabricProgramManager() {
//   const fileInputRef = useRef();

//   // -------------------- Client & Form Data --------------------
//   const [formData, setFormData] = useState({
//     companyName: "",
//     season: "",
//     po: "",
//     reference: "",
//     orderFollowedBy: "",
//     orderFollowUpContact: "",
//   });

//   // -------------------- Process Losses (Customizable) --------------------
//   const [losses, setLosses] = useState({
//     knitting: 2,
//     mercerizing: 7,
//     dyeing: 4,
//     finishing: 4,
//     printing: 8,
//   });

//   // -------------------- Excel Data --------------------
//   const [modifiedData, setModifiedData] = useState(null);

//   // -------------------- Form Change Handlers --------------------
//   const handleFormChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleLossChange = (e) => {
//     const { name, value } = e.target;
//     setLosses({ ...losses, [name]: parseFloat(value) || 0 });
//   };

//   // -------------------- Form Validation --------------------
//   const isFormValid =
//     formData.companyName.trim() &&
//     formData.reference.trim() &&
//     formData.orderFollowedBy.trim() &&
//     formData.orderFollowUpContact.trim();

//   // -------------------- Upload Excel --------------------
//   const handleUploadClick = () => {
//     if (!isFormValid) return;
//     fileInputRef.current.click();
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();
//     reader.onload = (e) => {
//       const data = new Uint8Array(e.target.result);
//       const workbook = XLSX.read(data, { type: "array" });
//       const sheet = workbook.Sheets[workbook.SheetNames[0]];
//       let jsonData = XLSX.utils.sheet_to_json(sheet);

//       // -------------------- Sort by Fabric then Dia --------------------
//       jsonData.sort((a, b) => {
//         const fabricA = (a["Fabric"] || "").toString().toLowerCase();
//         const fabricB = (b["Fabric"] || "").toString().toLowerCase();
//         if (fabricA < fabricB) return -1;
//         if (fabricA > fabricB) return 1;

//         const diaA = (a["Dia"] || "").toString();
//         const diaB = (b["Dia"] || "").toString();
//         return diaA.localeCompare(diaB);
//       });

//       // -------------------- Calculate Yarn Quantity (Reverse Efficiency) --------------------
//       jsonData = jsonData.map((row) => {
//         const requiredWeight = parseFloat(row["Required Weight"]) || 0;

//         // Detect if Mercerizing / Printing applies
//         const hasMercerizing =
//           row["Mercerizing"]?.toString().toLowerCase() === "yes";
//         const hasPrinting = row["Printing"]?.toString().toLowerCase() === "yes";

//         // Build Loss Chain
//         let processLosses = [];

//         // Step 1: Knitting always applied
//         processLosses.push(losses.knitting);

//         // Step 2: Mercerizing (optional)
//         if (hasMercerizing) processLosses.push(losses.mercerizing);

//         // Step 3: Dyeing always applied
//         processLosses.push(losses.dyeing);

//         // Step 4: First finishing always applied
//         processLosses.push(losses.finishing);

//         // Step 5: Printing + extra finishing (optional)
//         if (hasPrinting) {
//           processLosses.push(losses.printing);
//           processLosses.push(losses.finishing);
//         }

//         // Calculate cumulative efficiency
//         let cumulativeEfficiency = processLosses.reduce(
//           (acc, loss) => acc * (1 - loss / 100),
//           1
//         );

//         // Yarn Required = Required ÷ Efficiency
//         const yarnRequired = parseFloat(
//           (requiredWeight / cumulativeEfficiency).toFixed(2)
//         );

//         // Remove Net Weight column if exists
//         const { ["Net Weight"]: _, ...rest } = row;

//         return {
//           ...rest,
//           "Yarn Quantity": yarnRequired,
//         };
//       });

//       setModifiedData(jsonData);
//     };
//     reader.readAsArrayBuffer(file);
//   };

//   // -------------------- Download Template --------------------
//   const handleDownloadTemplate = () => {
//     if (!isFormValid) return;
//     const publicPath = process.env.PUBLIC_URL + "/Fabric_Program_Template.xlsx";
//     const link = document.createElement("a");
//     link.href = publicPath;
//     link.download = "Fabric_Program_Template.xlsx";
//     document.body.appendChild(link);
//     link.click();
//     link.remove();
//   };

//   // -------------------- Download Modified Excel --------------------
//   const handleDownloadModified = () => {
//     if (!modifiedData) return;
//     const worksheet = XLSX.utils.json_to_sheet(modifiedData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Modified Data");
//     XLSX.writeFile(workbook, "Modified_Fabric_Program.xlsx");
//   };

//   // -------------------- Render --------------------
//   return (
//     <div className="min-h-screen bg-gray-100 p-4 flex items-center justify-center">
//       <div className="bg-white p-8 rounded-xl shadow-lg max-w-6xl w-full flex flex-col md:flex-row md:space-x-8">
//         {/* Left Section: Client Details + Process Losses */}
//         <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-6">
//           {/* Client Details */}
//           {[
//             { label: "Client Name", name: "companyName", required: true },
//             { label: "Season", name: "season" },
//             { label: "PO", name: "po" },
//             { label: "Reference", name: "reference", required: true },
//             {
//               label: "Order Followed By",
//               name: "orderFollowedBy",
//               required: true,
//             },
//             {
//               label: "Order Follow up Contact",
//               name: "orderFollowUpContact",
//               required: true,
//             },
//           ].map((field) => (
//             <label key={field.name} className="flex flex-col">
//               <span className="font-medium text-gray-700">
//                 {field.label}{" "}
//                 {field.required && <span className="text-red-600">*</span>}
//               </span>
//               <input
//                 name={field.name}
//                 value={formData[field.name]}
//                 onChange={handleFormChange}
//                 type="text"
//                 placeholder={`Enter ${field.label.toLowerCase()}`}
//                 className="mt-1 px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
//                 required={field.required}
//               />
//             </label>
//           ))}

//           {/* Process Losses Customization */}
//           <div className="md:col-span-2">
//             <h3 className="font-semibold mb-2">Customize Process Loss (%)</h3>
//             <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
//               {Object.keys(losses).map((key) => (
//                 <label key={key} className="flex flex-col">
//                   <span className="font-medium capitalize">{key} Loss (%)</span>
//                   <input
//                     type="number"
//                     name={key}
//                     value={losses[key]}
//                     onChange={handleLossChange}
//                     className="mt-1 px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
//                   />
//                 </label>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Right Section: Buttons */}
//         <div className="flex flex-col space-y-4 mt-6 md:mt-0 md:flex-col md:justify-center md:w-48">
//           <button
//             onClick={handleDownloadTemplate}
//             disabled={!isFormValid}
//             className={`px-6 py-3 rounded-lg shadow text-white transition ${
//               isFormValid
//                 ? "bg-blue-600 hover:bg-blue-700"
//                 : "bg-blue-300 cursor-not-allowed"
//             }`}
//           >
//             Download Template
//           </button>

//           <button
//             onClick={handleUploadClick}
//             disabled={!isFormValid}
//             className={`px-6 py-3 rounded-lg shadow text-white transition ${
//               isFormValid
//                 ? "bg-green-600 hover:bg-green-700"
//                 : "bg-green-300 cursor-not-allowed"
//             }`}
//           >
//             Upload File
//           </button>

//           <input
//             type="file"
//             ref={fileInputRef}
//             onChange={handleFileChange}
//             className="hidden"
//           />

//           {modifiedData && (
//             <button
//               onClick={handleDownloadModified}
//               className="px-6 py-3 rounded-lg shadow text-white transition bg-purple-600 hover:bg-purple-700"
//             >
//               Download Modified Excel
//             </button>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useRef, useState } from "react";
import * as XLSX from "xlsx";

export default function FabricProgramManager() {
  const fileInputRef = useRef();

  // -------------------- Client & Form Data --------------------
  const [formData, setFormData] = useState({
    companyName: "",
    season: "",
    po: "",
    reference: "",
    orderFollowedBy: "",
    orderFollowUpContact: "",
  });

  // -------------------- Process Losses (Customizable) --------------------
  const [losses, setLosses] = useState({
    knitting: 2,
    mercerising: 7,
    dyeing: 4,
    finishing: 4,
    printing: 8,
  });

  // -------------------- Excel Data --------------------
  const [modifiedData, setModifiedData] = useState(null);

  // -------------------- Handlers --------------------
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleLossChange = (e) => {
    const { name, value } = e.target;
    setLosses({ ...losses, [name]: parseFloat(value) || 0 });
  };

  const isFormValid =
    formData.companyName.trim() &&
    formData.reference.trim() &&
    formData.orderFollowedBy.trim() &&
    formData.orderFollowUpContact.trim();

  const handleUploadClick = () => {
    if (!isFormValid) return;
    fileInputRef.current.click();
  };

  // -------------------- File Upload --------------------
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      let jsonData = XLSX.utils.sheet_to_json(sheet);

      // -------------------- Sort by Fabric then Width/Dia --------------------
      jsonData.sort((a, b) => {
        const fabricA = (a["Fabric"] || "").toString().toLowerCase();
        const fabricB = (b["Fabric"] || "").toString().toLowerCase();
        if (fabricA < fabricB) return -1;
        if (fabricA > fabricB) return 1;

        const diaA = (a["Width"] || a["Dia"] || "").toString();
        const diaB = (b["Width"] || b["Dia"] || "").toString();
        return diaA.localeCompare(diaB);
      });

      // -------------------- Calculate Yarn Quantity --------------------
      jsonData = jsonData.map((row) => {
        const requiredWeight = parseFloat(row["Required Weight"]) || 0;

        // Detect optional processes
        const hasMercerising =
          row["Mercerising"]?.toString().toLowerCase() === "yes";
        const hasPrinting =
          row["Print Type"]?.toString().toLowerCase() === "yes";

        // Build loss sequence
        let processLosses = [];

        // Knitting always
        processLosses.push(losses.knitting);

        // Mercerising if Yes
        if (hasMercerising) processLosses.push(losses.mercerising);

        // Dyeing always
        processLosses.push(losses.dyeing);

        // First finishing always
        processLosses.push(losses.finishing);

        // Printing + extra finishing if Yes
        if (hasPrinting) {
          processLosses.push(losses.printing);
          processLosses.push(losses.finishing);
        }

        // Backtrack yarn sequentially
        let yarnRequired = requiredWeight;
        processLosses.forEach((loss) => {
          yarnRequired = yarnRequired / (1 - loss / 100);
        });

        yarnRequired = parseFloat(yarnRequired.toFixed(2));

        // Return updated row
        const { ["Net Weight"]: _, ...rest } = row;
        return {
          ...rest,
          "Yarn Quantity": yarnRequired,
        };
      });

      setModifiedData(jsonData);
    };
    reader.readAsArrayBuffer(file);
  };

  // -------------------- Downloads --------------------
  const handleDownloadTemplate = () => {
    if (!isFormValid) return;
    const publicPath = process.env.PUBLIC_URL + "/Fabric_Program_Template.xlsx";
    const link = document.createElement("a");
    link.href = publicPath;
    link.download = "Fabric_Program_Template.xlsx";
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const handleDownloadModified = () => {
    if (!modifiedData) return;
    const worksheet = XLSX.utils.json_to_sheet(modifiedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Modified Data");
    XLSX.writeFile(workbook, "Modified_Fabric_Program.xlsx");
  };

  // -------------------- Render --------------------
  return (
    <div className="min-h-screen bg-gray-100 p-4 flex items-center justify-center">
      <div className="bg-white p-8 rounded-xl shadow-lg max-w-6xl w-full flex flex-col md:flex-row md:space-x-8">
        {/* Left Section: Client Details + Process Losses */}
        <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Client Details */}
          {[
            { label: "Client Name", name: "companyName", required: true },
            { label: "Season", name: "season" },
            { label: "PO", name: "po" },
            { label: "Reference", name: "reference", required: true },
            {
              label: "Order Followed By",
              name: "orderFollowedBy",
              required: true,
            },
            {
              label: "Order Follow up Contact",
              name: "orderFollowUpContact",
              required: true,
            },
          ].map((field) => (
            <label key={field.name} className="flex flex-col">
              <span className="font-medium text-gray-700">
                {field.label}{" "}
                {field.required && <span className="text-red-600">*</span>}
              </span>
              <input
                name={field.name}
                value={formData[field.name]}
                onChange={handleFormChange}
                type="text"
                placeholder={`Enter ${field.label.toLowerCase()}`}
                className="mt-1 px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                required={field.required}
              />
            </label>
          ))}

          {/* Process Losses Customization */}
          <div className="md:col-span-2">
            <h3 className="font-semibold mb-2">Customize Process Loss (%)</h3>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              {Object.keys(losses).map((key) => (
                <label key={key} className="flex flex-col">
                  <span className="font-medium capitalize">{key} Loss (%)</span>
                  <input
                    type="number"
                    name={key}
                    value={losses[key]}
                    onChange={handleLossChange}
                    className="mt-1 px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                  />
                </label>
              ))}
            </div>
          </div>
        </div>

        {/* Right Section: Buttons */}
        <div className="flex flex-col space-y-4 mt-6 md:mt-0 md:flex-col md:justify-center md:w-48">
          <button
            onClick={handleDownloadTemplate}
            disabled={!isFormValid}
            className={`px-6 py-3 rounded-lg shadow text-white transition ${
              isFormValid
                ? "bg-blue-600 hover:bg-blue-700"
                : "bg-blue-300 cursor-not-allowed"
            }`}
          >
            Download Template
          </button>

          <button
            onClick={handleUploadClick}
            disabled={!isFormValid}
            className={`px-6 py-3 rounded-lg shadow text-white transition ${
              isFormValid
                ? "bg-green-600 hover:bg-green-700"
                : "bg-green-300 cursor-not-allowed"
            }`}
          >
            Upload File
          </button>

          <input
            type="file"
            ref={fileInputRef}
            onChange={handleFileChange}
            className="hidden"
          />

          {modifiedData && (
            <button
              onClick={handleDownloadModified}
              className="px-6 py-3 rounded-lg shadow text-white transition bg-purple-600 hover:bg-purple-700"
            >
              Download Modified Excel
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
